import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Breadcrumbs as BreadcrumbsZDS, Link } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { useTracking } from '../../tracking';
const styles = labelStyles('Breadcrumbs', {
    root: css({
        margin: '0 auto',
        maxWidth: '1170px',
        padding: '20px',
    }),
});
export function Breadcrumbs(props) {
    var _a;
    const { emitUserInteractionEvent } = useTracking();
    return (_jsx("div", Object.assign({ css: styles.root }, { children: _jsxs(BreadcrumbsZDS, Object.assign({ size: props.size }, { children: [(_a = props.links) === null || _a === void 0 ? void 0 : _a.map((link) => (_jsx(Link, Object.assign({ href: link.href, onClick: () => {
                        emitUserInteractionEvent({
                            event_action: 'click',
                            interaction_name: 'navigation',
                            interaction_raw_text: link.text,
                            option_selected: 'breadcrumb_link',
                            destination_href: link.href,
                        });
                    } }, { children: link.text }), link.href))), props.currentPage && _jsx("span", { children: props.currentPage })] })) })));
}
//# sourceMappingURL=Breadcrumbs.js.map